import React, { useState, useEffect } from "react";
import styled from "styled-components";
import Navbar from "../../components/layout/Navbar/Navbar";
import Sidebar from "../../components/layout/Sidebar/Sidebar";
import CampisCadastradosHeader from "../../components/features/campis/CampisCadastradosHeader";
import CampisCadastrados from "../../components/features/campis/CampisCadastrados";
import { getCargoIdSidebar } from "../../constants/sidebarConfig";
import apiService from "../../services/api";

const NAVBAR_HEIGHT = 65;
const SIDEBAR_WIDTH = 300;

const PageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100vh;
  background: #f9f9f9;
`;

const ContentWrapper = styled.div`
  display: flex;
  flex: 1;
  margin-top: 60px;
`;

const MainContent = styled.main`
  flex: 1;
  margin-left: ${SIDEBAR_WIDTH}px; /* libera espaço para o sidebar fixo */
  overflow-y: auto;
  height: calc(100vh - ${NAVBAR_HEIGHT}px); /* limita para scroll interno */
`;

const Campis = () => {
  const [user, setUser] = useState(null);
  const [sidebarItems, setSidebarItems] = useState([]);
  const [sortOrder, setSortOrder] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');

  useEffect(() => {
    const fetchUser = async () => {
      try {
        const userData = await apiService.getCurrentUser();
        setUser(userData);
        const filteredItems = getCargoIdSidebar(userData.cargoId);
        setSidebarItems(filteredItems);
      } catch (err) {
        console.error('Erro ao buscar usuário:', err);
      }
    };

    fetchUser();
  }, []);

  return (
    <PageWrapper>
      <Navbar 
        onLogout={apiService.logout}
        showHome={true}
        showNotifications={true}
        showProfile={true}
        showLogout={true}
        user={user}
      />
      <ContentWrapper>
        <Sidebar items={sidebarItems} />
        <MainContent>
          <CampisCadastradosHeader 
            user={user} 
            onSortChange={setSortOrder} 
            searchValue={searchTerm}
            onSearchChange={setSearchTerm}
          />
          <CampisCadastrados 
            user={user} 
            sortOrder={sortOrder} 
            searchTerm={searchTerm}
          />
        </MainContent>
      </ContentWrapper>
    </PageWrapper>
  );
};

export default Campis;
